<template>
  <v-snackbar
    v-model="popUpNotification"
    @input="popUpClose()"
    :timeout="popUpTimeout"
    multi-line
    right
    bottom
  >
    <v-icon large class="mr-2" :color="popUpContent.level.toLowerCase()">{{
      popUpContent.level.toLowerCase()
    }}</v-icon>
    {{ popUpContent.content }}
    <v-btn icon @click="popUpClose()">
      <v-icon color="rgba(255,255,255,0.3)">cancel</v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
import {EventBus} from "@/lib/event-bus";
import {EVENTBUS_TOPICS} from "@/lib/constants";

export default {
  name: "notification-popup",
  data() {
    return {
      popUpContent: { title: "Test", level: "info" },
      popUpNotification: false,
      popUpQueue: [],
      popUpTimeout: 5000,
    };
  },
  methods: {
    popUpClose() {
      this.popUpNotification = false;
      if (this.notificationsInPopUpQueue) {
        this.popUpContent = this.popUpQueue.shift();
        setTimeout(() => {
            this.popUpNotification = true;
          },
          250
        );
      }
    },
  },
  computed: {
    notificationsInPopUpQueue() {
      return this.popUpQueue.length > 0;
    },
  },
  mounted() {
    EventBus.$on(EVENTBUS_TOPICS.NEW_NOTIFICATION, (notification) => {
      if (this.popUpNotification) {
        this.popUpQueue.push(notification);
      } else {
        this.popUpContent = notification;
        this.popUpNotification = true;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.NEW_NOTIFICATION);
  },
};
</script>
<style scoped>
</style>
